import { http } from "../http/Http";
import { GetByFiltersArguments } from "../models/GetByFiltersArguments";
import { ServiceResponse } from "../models/ServiceResponse";
import { Shipment } from "../models/Shipment";
import { ShipmentList } from "../models/ShipmentList";
import { DigitalShipmentFilters } from "../models/DigitalShipmentFilters";
import { DigitalShipmentFiltersCounts } from "../models/DigitalShipmentFiltersCounts";


export class ShipmentService{

    getShipmentsByFilters = async (apiQueryFilter: GetByFiltersArguments): Promise<ServiceResponse<ShipmentList[]>> => {
        const { data } = await http.post<ServiceResponse<ShipmentList[]>>("Shipment/GetByFilters", apiQueryFilter);
        return data;
    };

    getShipmentByEntityNumber = async (entityNumber: string): Promise<Shipment> => {
        const { data } = await http.get<Shipment>(("Shipment/GetByEntityNumber/" + entityNumber.toString()));
        return data;
    };

    getShipmentByEntityNumberWithAdditionalFields = async (entityNumber: string): Promise<Shipment> => {
        const { data } = await http.get<Shipment>(("Shipment/GetByEntityNumberWithAdditionalFields/" + entityNumber.toString()));
        return data;
    };
    
    getFiltersCounts = async (digitalShipmentFilters: DigitalShipmentFilters): Promise<DigitalShipmentFiltersCounts> => {
        const { data } = await http.post<DigitalShipmentFiltersCounts>("Shipment/GetFiltersCounts", digitalShipmentFilters);
        return data;
    };
    
}